import { render, staticRenderFns } from "./IndustryThemeNewsList.vue?vue&type=template&id=55151276&scoped=true"
import script from "./IndustryThemeNewsList.vue?vue&type=script&lang=js"
export * from "./IndustryThemeNewsList.vue?vue&type=script&lang=js"
import style0 from "./IndustryThemeNewsList.vue?vue&type=style&index=0&id=55151276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55151276",
  null
  
)

export default component.exports